module.exports = __webpack_public_path__ + "img/wavy-check.ad13b673.svg";